import { useMemo } from 'react';

import type { ActivationCapability, Edition } from '../../services/modal-data/types';
import { messages as confirmationMessages } from './screens/confirmation-screen/messages';

export const useConfirmationScreenMessages = ({
	edition,
	activationCapability,
	hasPaymentDetails,
}: {
	activationCapability: ActivationCapability;
	edition: Edition;
	hasPaymentDetails: boolean;
}): {
	ctaText: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	subheader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} => {
	const canActivate = activationCapability === 'can-activate';
	const subheader = useMemo(() => {
		if (!canActivate) {
			return confirmationMessages.requestTrialText;
		}
		return edition === 'premium'
			? confirmationMessages.trialTextPremiumPriceIncrease
			: confirmationMessages.trialTextStandardPriceIncrease;
	}, [edition, canActivate]);
	const ctaText = useMemo(() => {
		if (!canActivate) {
			return confirmationMessages.ctaRequestTrialText;
		}
		return hasPaymentDetails
			? confirmationMessages.ctaWithPaymentDetailsOnFile
			: confirmationMessages.ctaNoPaymentDetailsOnFile;
	}, [hasPaymentDetails, canActivate]);

	return {
		subheader,
		ctaText,
	};
};
